import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { __ } from '@app/shared/functions/object.functions';
import { Observable, of } from 'rxjs';
import { finalize, map } from 'rxjs';

import { FormDeactivateableDialogComponent } from './dialog/form-deactivateable-dialog.component';
import { IFormDeactivateable } from './IDeactivateable';

@Injectable()
export class FormDeactiviationGuard {
  private dialog = inject(MatDialog);

  private isOpen: boolean = false;

  canDeactivate(component: IFormDeactivateable): Observable<boolean> {
    if (
      !__.IsNullOrUndefined(component.hasPendingChanges) &&
      this.isOpen === false &&
      component.hasPendingChanges() === true
    ) {
      this.isOpen = true;

      return this.dialog
        .open(FormDeactivateableDialogComponent)
        .afterClosed()
        .pipe(
          finalize(() => {
            this.isOpen = false;
          }),
          map((result: unknown) => {
            if (!__.IsNullOrUndefined(result)) {
              return true;
            } else {
              return false;
            }
          }),
        );
    }
    return of(true);
  }
}
